import React from 'react';
import { useSelector } from 'react-redux';
import { Box, Text, Spacer, SideSheet } from '@flexisaf/flexibull2';
import PropTypes from 'prop-types';
import Theme from 'utils/theme';
import { formatNumber } from 'utils/formatNumber';
import { currencyTags, EMPTY_VALUE, FALL_BACK_TZ } from 'utils/constants';
import { selectInstitution } from 'redux/configurations/selectors';
import { calculateDateOffset } from 'utils/helpers';
const moment = require('moment-timezone');

export const TransactionHistoryDetails = ({
  current,
  platformCheck,
  handleCurrent,
  handleModal,
  show,
}) => {
  const institution = useSelector(selectInstitution);

  if (!current) {
    return null;
  }

  return (
    <SideSheet
      width="500px"
      open={show}
      onClose={() => {
        handleCurrent(null);
        handleModal(false);
      }}
    >
      <Box
        pad="20px 50px 50px"
        style={{
          overflowY: 'auto',
          height: '100vh',
        }}
      >
        <h2 style={{ fontWeight: 500 }}>Transaction Details</h2>

        <Box margin="40px 0 0">
          <Text
            uppercase
            bold
            size="11px"
            color={Theme.PrimaryInputOutline}
            block
          >
            Payers Information
          </Text>
          <Spacer />
          <Text capitalize block>
            {current?.name}
          </Text>
          <Spacer space="5px" />
          <Text capitalize block>
            {current?.email}
          </Text>
        </Box>

        <Box margin="40px 0 0">
          <Text
            uppercase
            bold
            size="11px"
            color={Theme.PrimaryInputOutline}
            block
          >
            Application
          </Text>
          <Spacer />
          <Text capitalize block>
            {current?.application.title}
          </Text>
          <Spacer space="5px" />
          <Text capitalize block>
            {current?.course.code} - {current?.course.title}
          </Text>
        </Box>

        <Box margin="40px 0 0">
          <Text
            uppercase
            bold
            size="11px"
            color={Theme.PrimaryInputOutline}
            block
          >
            Time Stamp
          </Text>
          <Spacer />
          <Text capitalize block>
            {moment(
              calculateDateOffset(current?.createdAt, institution?.timeZone)
            )
              .tz(institution?.timeZone || FALL_BACK_TZ)
              .format('MMMM Do YYYY, h:mm:ss a')}
          </Text>
        </Box>

        <Box margin="40px 0 0">
          <Text
            uppercase
            bold
            color={Theme.PrimaryInputOutline}
            size="11px"
            block
          >
            {' '}
            Platform
          </Text>
          <Spacer />
          <Text capitalize block size="25px">
            {platformCheck(current?.platform.toLowerCase())}
          </Text>
        </Box>

        <Box
          display="flex"
          style={{ justifyContent: 'space-between' }}
          margin="40px 0 0"
        >
          <Box>
            <Text
              uppercase
              bold
              size="11px"
              color={Theme.PrimaryInputOutline}
              block
            >
              {' '}
              Transaction Reference
            </Text>
            <Spacer />
            <Text capitalize block>
              {' '}
              {current?.reference}
            </Text>
          </Box>
          <Box>
            <Text
              uppercase
              bold
              color={Theme.PrimaryInputOutline}
              size="11px"
              block
            >
              {' '}
              RRR
            </Text>
            <Spacer />
            <Text capitalize block>
              {' '}
              {!current.rrr ? EMPTY_VALUE : current.rrr}
            </Text>
          </Box>
        </Box>

        <Box margin="40px 0 0">
          <Text
            uppercase
            bold
            color={Theme.PrimaryInputOutline}
            size="13px"
            block
          >
            Transaction Summary
          </Text>
          <Box
            round="5px"
            style={{ boxShadow: '#4e399212  -3px 0px 20px 2px' }}
            margin="20px 0 0"
            pad="1px 0 0"
            background="#fff"
          >
            {current?.items
              .filter((fee) => fee.amount !== 0)
              .map((fee, i) => (
                <Box
                  key={i}
                  display="flex"
                  style={{ justifyContent: 'space-between' }}
                  margin="25px 20px 0"
                >
                  <Text capitalize block>
                    {fee.name}
                    {fee.tag && (
                      <Text size="11px" color={Theme.PrimaryGrey} style={{ marginLeft: 6 }}>
                        ({fee.tag})
                      </Text>
                    )}
                  </Text>
                  <Text capitalize block bold size="14px">
                    {currencyTags[fee?.currency || 'NGN']}
                    {formatNumber(fee.amount)}
                  </Text>
                </Box>
              ))}
              {current?.gatewayCharge !== 0 && (
                <Box
                  display="flex"
                  style={{ justifyContent: 'space-between' }}
                  margin="25px 20px 0"
                >
                  <Text capitalize block>
                    Payment Gateway Fee
                  </Text>
                  <Text capitalize block bold size="14px">
                    {currencyTags[current?.currency || 'NGN']}{' '}
                    {formatNumber(current?.gatewayCharge)}
                  </Text>
                </Box>
              )}
            <Box
              margin="20px 0 0"
              background={Theme.PrimaryFade}
              height="1px"
            />
            <Box
              background={Theme.PrimaryFade}
              pad="25px 20px"
              display="flex"
              style={{ justifyContent: 'space-between' }}
            >
              <Text uppercase block>
                Total Amount
              </Text>
              <Text
                capitalize
                color={Theme.PrimaryGreen}
                block
                bold
                size="17px"
              >
                {currencyTags[current?.currency || 'NGN']}
                {formatNumber(current?.amount + current?.gatewayCharge || 0)}
              </Text>
            </Box>
          </Box>
        </Box>
      </Box>
    </SideSheet>
  );
};

TransactionHistoryDetails.propTypes = {
  current: PropTypes.object,
  platformCheck: PropTypes.func,
  handleCurrent: PropTypes.func,
  handleModal: PropTypes.func,
  show: PropTypes.bool,
};
